import { defineMessages } from 'react-intl';

export const listingStateMessages = defineMessages({
  internal: {
    defaultMessage: 'Internal',
    description: 'Opening listing state: only internal applicants can apply',
  },
  not_posted: {
    defaultMessage: 'Not posted',
    description: 'Opening listing state: the opening is not published',
  },
  intake_closed: {
    defaultMessage: 'Intake closed',
    description:
      'Opening listing state: the opening no longer accepts applications',
  },
});

export const postingUnavailableMessages = defineMessages({
  title: {
    defaultMessage: "This opening isn't available to post",
    description:
      'Posting to job boards is blocked because the opening is not Public',
  },
  description: {
    defaultMessage:
      'The sourcing status is {state}. Set it to Public to post this opening to job boards.',
    description:
      'The opening sourcing status {state} blocks posting; Public is the required sourcing status',
  },
  edit: {
    defaultMessage: 'Edit opening',
    description: 'Open the opening settings to change its listing state',
  },
  multiple: {
    defaultMessage:
      'None of the selected openings are eligible for posting. Make each opening active and Public to post to job boards.',
    description:
      'All selected openings are blocked; Public is the required listing state',
  },
});
